import Fade from "react-reveal/Fade";
import {
  BusContainer,
  BusWrapper,
  BusRow,
  Column1,
  Column2,
  TextWrapper,
  Heading,
  Subtitle,
  CTASection,
  CTAButton,
  ImgWrap,
  Img,
} from "./BusinessElements";

const BusSection = ({ id, headline, imgStart, img, alt, buttonLabel }) => {
  return (
    <>
      <BusContainer id={id}>
        <BusWrapper>
          <BusRow imgStart={imgStart}>
            <Fade right>
              <Column1>
                <TextWrapper>
                  <Heading>{headline}</Heading>
                  <Subtitle>
                    Paythumb provides businesses a fast and secure way of
                    accepting cashless payments.
                  </Subtitle>
                  <Subtitle>
                    With low transaction fees, Paythumb For Business suits all
                    kinds of businesses.
                  </Subtitle>

                  <Subtitle>
                    Start accepting Paythumb payments at no cost with a{" "}
                    <strong>90-day free trial.</strong>
                  </Subtitle>
                </TextWrapper>

                <CTASection>
                  <CTAButton
                    to="Waitlist"
                    smooth={true}
                    duration={500}
                    spy={true}
                    exact="true"
                    offset={-80}
                  >
                    {buttonLabel}
                  </CTAButton>
                </CTASection>
              </Column1>
            </Fade>
            <Column2>
              <ImgWrap>
                <Img src={img} alt={alt} />
              </ImgWrap>
            </Column2>
          </BusRow>
        </BusWrapper>
      </BusContainer>
    </>
  );
};

export default BusSection;
